
import Dashboard from '../components/dashboard';
import Login from '../components/login';
import ForgotPasswordPage from '../components/ForgotPasswordPage';

import EducationalVideoPlayer from '../components/EducationalVideos/EducationalVideoPlayer';
import LearnView from '@views/LearnView';
import MorePage from '@components/MorePage';
import AccountPage from '@components/AccountPage';
import AccountNamePage from '@components/AccountNamePage';
import AccountPhonePage from '@components/AccountPhonePage';
import ChangePasswordPage from '@components/ChangePasswordPage';
import SupportPage from '@components/SupportPage';
import StatusReview from '@components/StatusReview';
import SubscriptionPage from '@components/SubscriptionPage';

const routes = [
  {
    path: '/',
    component: Login,
  },
  {
    path: '/forgot-password',
    component: ForgotPasswordPage,
  },
  {
    path: '/dashboard',
    component: Dashboard,
  },
  {
    path: '/videos',
    component: LearnView,
  },
  {
    path: '/videos/:videoId',
    component: EducationalVideoPlayer,
  },
  {
  path: '/more',
  component: MorePage,
},
  {
    path: '/account',
    component: AccountPage,
  },
  {
    path: '/account-name',
    component: AccountNamePage,
  },
  {
    path: '/account-phone',
    component: AccountPhonePage,
  },
  {
    path: '/change-password',
    component: ChangePasswordPage,
  },
  {
  path: '/support',
  component: SupportPage,
},
{
  path: '/access',
  component: StatusReview,
},
  {
    path: '/subscription',
    component: SubscriptionPage,
  },
];

export default routes;
